import { Collapse as MuiCollapse, } from '@mui/material';
export const Collapse = MuiCollapse;
